// Storeを生成
export default {
  state: {
    id: null,
    email: null,
    token: null,
    user: {}
  },
  getters: {
    isLogin(state: any) {
      return !!state.token;
    }
  },
  mutations: {
    setId(state: any, id: number) {
      state.id = id;
    },
    setEmail(state: any, email: any) {
      state.email = email;
    },
    setIdToken(state: any, token: any) {
      state.token = token;
    },
    setUser(state: any, user: object) {
      state.user = user;
    },
    clearAuthState(state: any) {
      (state.id = null),
        (state.email = null),
        (state.token = null),
        (state.user = {});
    }
  },
  actions: {
    actionSetId(context: any, id: number) {
      context.commit("setId", id);
    },
    actionSetEmail(context: any, email: any) {
      context.commit("setEmail", email);
    },
    actionSetUser(context: any, user: object) {
      context.commit("setUser", user);
    },
    actionSetIdToken(context: any, token: any) {
      context.commit("setIdToken", token);
    }
  }
};
